import { getAllDescendantsForItem } from '../../../helpers/getAllDescendantsForItem'
import { ITreeStructure } from '../../../models/treeStructure'

export const getDisplayValues = (original: ITreeStructure[]): ITreeStructure[] => {
  const result: ITreeStructure[] = []
  const selectedItems = structuredClone(original)

  for (let i = 0; i < selectedItems.length; i++) {
    const current = selectedItems[i]
    if (current.hasChildren && current.checkedState === 'full') {
      const descendants = getAllDescendantsForItem(current)
        .map((it) => it.itemId)
        .filter((entryId) => current.itemId !== entryId)

      for (const descendantId of descendants) {
        const index = selectedItems.findIndex((it) => it.itemId === descendantId)
        selectedItems.splice(index, 1)
      }
      result.push(current)
      selectedItems.splice(i, 1)
      i--
      continue
    }

    if (current.checkedState === 'full') {
      result.push(current)
    }
  }

  return result
}
